import { create } from "zustand";
import { Socket } from "socket.io-client";

export enum ConnectionStatus {
  CONNECTED = "connected",
  DISCONNECTED = "disconnected",
  RECONNECTING = "reconnecting",
}

type State = {
  socket: Socket | null;
  wsConnectionStatus: ConnectionStatus;
  // TODO: Discuss with Andrei
  lastOnlineTimestamp: string;
  lastOfflineTimestamp: string;
  networkStatus: "online" | "offline";
};

type Actions = {
  setSocket: (socket: Socket | null) => void;
  setWsConnectionStatus: (status: ConnectionStatus) => void;
  setLastOnlineTimestamp: (timestamp: string) => void;
  setLastOfflineTimestamp: (timestamp: string) => void;
  setNetworkStatus: (status: "online" | "offline") => void;
  resetConnectionState: () => void;
};

const initialState: State = {
  socket: null,
  wsConnectionStatus: ConnectionStatus.DISCONNECTED,
  lastOnlineTimestamp: "",
  lastOfflineTimestamp: "",
  networkStatus: navigator.onLine ? "online" : "offline",
};

export const useConnectionState = create<State & Actions>()((set) => ({
  // State
  ...initialState,

  // Actions
  setSocket: (socket: Socket | null) => set({ socket }),
  setWsConnectionStatus: (status) => set({ wsConnectionStatus: status }),
  setLastOnlineTimestamp: (timestamp: string) =>
    set({ lastOnlineTimestamp: timestamp }),
  setLastOfflineTimestamp: (timestamp: string) =>
    set({ lastOfflineTimestamp: timestamp }),
  setNetworkStatus: (status) => set({ networkStatus: status }),

  resetConnectionState: () => {
    set(initialState);
  },
}));
